<template>
  <div class="colors__wrapper">
    <SRadioButton
      v-for="(color, i) in avaliableColors"
      :key="i"
      :class="{ 'color-disabled': $wait.waiting('change color') }"
      :currently-selected-value="selectedColor"
      :value-on-selection="color"
      :label-text="color"
      :data-test="`color-picker-${color}`"
      radio-button-type="color-picker"
      name="color-selection"
      @change="(newValue) => (selectedColor = newValue)"
    />
  </div>
</template>

<script>
import SRadioButton from 'src/components/base/SRadioButton.vue'

export default {
  // TODO VUE3: Remove compatConfig when @vue/compat is removed
  compatConfig: {
    COMPONENT_V_MODEL: false,
  },

  name: 'SduiChooseLessonColor',
  components: { SRadioButton },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    selectedColor: null,
    avaliableColors: ['violet', 'purple', 'pink', 'red', 'orange', 'yellow', 'green', 'teal', 'cyan', 'blue', 'indigo', 'brown'],
  }),

  emits: ['update:modelValue'],

  watch: {
    selectedColor(val) {
      this.$emit('update:modelValue', val)
    },
  },

  created() {
    this.selectedColor = this.modelValue
  },
}
</script>

<style scoped lang="scss">
.colors__wrapper {
  text-align: center;
  max-width: 365px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
}

.color-disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>
